import React, { useCallback } from 'react';
import moment from 'moment/moment';

import { DatePickerClearButton } from 'components/pages/ModeReports/DatepickerClearButton/DatePickerClearButton';
import { DropdownSingleSelectCustomTemplate } from 'components/pages/ModeReports/DropdownSingleSelectCustomTemplate/DropdownSingleSelectCustomTemplate';
import { sortOptionsByFavorite } from 'components/pages/ModeReports/modeReportsServices';
import ReportStudyPcnMultiSelectFilter from 'components/pages/ModeReports/ReportStudyPcnMultiSelectFilter';

import DatePicker from '../../../../common/data-entry/DatePicker';
import Select from '../../../../common/data-entry/Select';
import { useModeReportsActions } from '../ModeReportsContext';
import { DATE_FORMAT } from '../modeReportsServices';
import ReportMultiSelectFilter from '../ReportMultiSelectFilter';

import ModeReportsStudyPcnSingleSelectFilter from './ModeReportsStudyPcnSingleSelectFilter';

import '../../../eui/EuiFiltersContext/controls/StudyPcn/StudyPcn.scss';

function ModeReportsFilterBuilder({
  filterKey,
  filterLabel,
  filterType,
  clearable,
  dataSource,
  selectedValues,
  selectedStudy,
  selectedLevel,
  selectedAggregation,
  controlId,
  onChangeFunctionName,
  selectedSite,
  isDateParameterOptional,
  favoriteOptions
}) {
  const valueFilterMapping = {
    studies: selectedStudy,
    levels: selectedLevel,
    aggregation: selectedAggregation,
    sites: selectedSite
  };
  const { dispatch, toggleFavoriteOption } = useModeReportsActions();
  const onChange = value => dispatch({ type: onChangeFunctionName, payload: { key: filterKey, value: value } });
  const onClear = value => dispatch({ type: 'ON_SELECT_DATE_CLEAR', payload: { key: filterKey, value: value } });

  const setOptionsAsFavorite = useCallback(
    option => {
      toggleFavoriteOption(option.id, filterKey);
    },
    [filterKey, toggleFavoriteOption]
  );
  if (filterKey === 'studies' && filterType === 'select') {
    return (
      <ModeReportsStudyPcnSingleSelectFilter
        controlId={controlId}
        filterLabel={filterLabel}
        dataSource={dataSource}
        value={valueFilterMapping[filterKey]}
        clearable={clearable}
        onChange={onChange}
        setOptionsAsFavorite={setOptionsAsFavorite}
        favoriteOptions={favoriteOptions}
      />
    );
  } else if (filterKey === 'studies' && filterType === 'multiselect') {
    return (
      <ReportStudyPcnMultiSelectFilter
        dataSource={dataSource}
        value={selectedValues}
        name={filterLabel}
        id={controlId}
        onChange={onChange}
        favoriteOptions={favoriteOptions}
        setOptionsAsFavorite={setOptionsAsFavorite}
      />
    );
  } else if (filterType === 'select') {
    return (
      <Select
        controlId={controlId}
        label={filterLabel}
        dataSource={sortOptionsByFavorite(dataSource, favoriteOptions)}
        value={valueFilterMapping[filterKey]}
        clearable={clearable}
        searchable={true}
        deselectOnSelectedOptionClick={true}
        clearSelectedValueOnDataSourceChange={false}
        onChange={onChange}
        validate={false}
        customOptionTemplateFunction={option => (
          <DropdownSingleSelectCustomTemplate
            option={option}
            setOptionsAsFavorite={setOptionsAsFavorite}
            favoriteOptions={favoriteOptions}
          />
        )}
        customSelectedValueTemplateFunction={option => <>{option[0]?.name}</>}
      />
    );
  } else if (filterType === 'multiselect') {
    return (
      <ReportMultiSelectFilter
        dataSource={dataSource}
        value={selectedValues}
        name={filterLabel}
        id={controlId}
        onChange={onChange}
        favoriteOptions={favoriteOptions}
        setOptionsAsFavorite={setOptionsAsFavorite}
      />
    );
  } else if (filterType === 'date picker') {
    return (
      <DatePicker
        iconsAfter={isDateParameterOptional && selectedValues && <DatePickerClearButton onClear={onClear} />}
        value={new moment(selectedValues, DATE_FORMAT)}
        onChange={onChange}
        id={controlId}
        label={filterLabel}
      />
    );
  } else {
    return undefined;
  }
}
export default ModeReportsFilterBuilder;
